import React from "react";
import {
  BOLD,
  ITALIC,
  NORMAL,
  STRIKETHROUGH,
  UNDERLINE
} from "../../constants/fontStyles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBold, faItalic, faStrikethrough, faUnderline } from "@fortawesome/free-solid-svg-icons";

/**
 * Handles change of text style for text block.
 *
 * @param {Object}   canvas   FabricJS Canvas Object
 *
 * @returns {Object}
 */
export default function Style({ canvas }) {
  const changeFontStyle = (selectedStyle) => {
    let currentStyle = null;
    let fontSetting = null;
    let defaultStyle = NORMAL;
    const activeObject = canvas.getActiveObject() || null;

    if (activeObject === null) {
      return;
    }

    switch(selectedStyle) {
      case BOLD:
        currentStyle = activeObject.fontWeight;
        fontSetting = 'fontWeight';
        break;
      case ITALIC:
        currentStyle = activeObject.fontStyle;
        fontSetting = 'fontStyle';
        break;
      case UNDERLINE:
        currentStyle = activeObject.underline;
        fontSetting = 'underline';
        defaultStyle = false;
        selectedStyle = true;
        break;
      case STRIKETHROUGH:
        currentStyle = activeObject.linethrough;
        fontSetting = 'linethrough';
        defaultStyle = false;
        selectedStyle = true;
        break;
    }

    /**
     * If object has default style, switch to selected
     * If object has the selected style, revert to default
     * Ex: First click of button makes text bold, second click removes the
     * bold and returns text to normal weight
     */
    const newStyle = currentStyle == defaultStyle
      ? selectedStyle
      : defaultStyle;

    activeObject.set(fontSetting, newStyle);
    canvas.renderAll();
  }

  return (
    <div id="styleTool" className="text-tool-inner">
      <div>Font Style</div>
      <button className="font-type" onClick={() => changeFontStyle('bold')}>
        <span className="tooltiptext">Bold</span>
        <FontAwesomeIcon icon={faBold} />
      </button>
      <button className="font-type" onClick={() => changeFontStyle('italic')}>
        <span className="tooltiptext">Italic</span>
        <FontAwesomeIcon icon={faItalic} />
      </button>
      <button className="font-type" onClick={() => changeFontStyle('underline')}>
        <span className="tooltiptext">Underline</span>
        <FontAwesomeIcon icon={faUnderline} />
      </button>
      <button className="font-type" onClick={() => changeFontStyle('strikethrough')}>
        <span className="tooltiptext">Strikethrough</span>
        <FontAwesomeIcon icon={faStrikethrough} />
      </button>
    </div>
  );
}
